import React from "react"

import Header from "./header"
import Footer from "./footer"

interface LayoutProps {
  children?: React.ReactNode
  location: Location
}

const Layout: React.FC<LayoutProps> = ({ children, location }) => {
  return (
    <>
      <Header location={location} />
      {children}
      <Footer />
    </>
  )
}

export default Layout
